<template>
  <search-bar :search="search" class-btn-search="btn btn-primary icon-magnifier form-group right" ref="search">
    <div class="row">
      <div class="col-md-6">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" style="width: 65px;">Cliente</span>
          </div>
          <input type="text"
                 class="form-control"
                 style="width: calc(100% - 65px);"
                  v-model="search.name"
                  v-on:keyup.enter="filtrar">
        </div>
      </div>
      <div class="col-md-6">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" style="width: 175px;">Código Centro de Custo</span>
          </div>
          <input type="number"
                 class="form-control"
                 style="width: calc(100% - 175px);"
                 v-model="search.centro_custo_sap"
                 v-on:keyup.enter="filtrar">
        </div>
      </div>
    </div>
  </search-bar>
</template>

<script>
  import { SearchBar } from 'metawesome-datatable';
  import Uteis from '@/mixins/utils.js';


  export default {
    components: {
      SearchBar,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        search: {
          name: '',
          centro_custo_sap: '',
          cc_id_not_null: true,
        },
      };
    },

    mounted() {
      this.$refs.search.$on('filter-set', (filter) => {
        this.$emit('filter-set', filter);
      });

      this.filtrar();
    },

    methods: {
      filtrar() {
        this.$emit('filter-set', this.search);
      },
    }
  };
</script>
